<template>
    <div class="create-button-container">
        <router-link :to="endpoint">
            <btn size="lg" type="primary">{{ title }}</btn>
        </router-link>
    </div>
</template>

<script>
    export default {
        props: {
            title: '',
            endpoint:''
        },
        data () {
            return {

            }
        },
        computed: {

        },
        methods: {

        }
    }
</script>

<style scoped lang="scss">
@import "../css/constants";

button {
    width: 160px;
    height: 34px;
    font-size: $p14;
    &:focus {
      outline: none;
    }
  }
  .create-button-container{
    width: 140%;
    overflow:hidden;
    background-color:white;
    margin-left: -1.5rem;
    padding-left: 26px;

  }

</style>


// WEBPACK FOOTER //
// src/components/CreateButton.vue